import { assessmentRoot } from "#/admin/legacy/assessment-builder/assessment-root.js";
import { assessmentSelectItems } from "#/admin/legacy/assessment-builder/assessment-select-items.js";
import "#vendor/humps.js";
import "./_generated_templates.js";
import.meta.glob("./collections/**/*.{js,hbs,jst.ejs}", { eager: true });
import.meta.glob("./models/**/*.{js,hbs,jst.ejs}", { eager: true });
import.meta.glob("./views/**/*.{js,hbs,jst.ejs}", { eager: true });
import.meta.glob("./serializers/**/*.{js,hbs,jst.ejs}", { eager: true });

// Preserve sub-namespaces populated by glob-hoisted children above before
// we overwrite `window.AssessmentBuilder` with the class below.
const _previousAssessmentBuilder = window.AssessmentBuilder;

window.AssessmentBuilder = class AssessmentBuilder {
  static Models = {};
  static Views = { Mixins: {} };
  static Collections = {};
  // Templates are loaded from _generated_templates.js (generated by `rake assets:generate_inline_templates`)
  static Events = {
    Relation: {
      changed: "relation-changed",
    },
    AssessmentNavigator: {
      introSelected: "assessmentNavigator-introSelected",
      introUnselected: "assessmentNavigator-introUnselected",
      submitterInfoSelected: "assessmentNavigator-submitterInfoSelected",
      submitterInfoUnselected: "assessmentNavigator-submitterInfoUnselected",
      questionSelected: "assessmentNavigator-questionSelected",
      questionUnselected: "assessmentNavigator-questionUnselected",
      completionPageSelected: "assessmentNavigator-completionPageSelected",
      completionPageUnselected: "assessmentNavigator-completionPageUnselected",
    },
    Intro: {
      clicked: "intro-clicked",
    },
    SubmitterInfo: {
      clicked: "submitter-info-clicked",
    },
    Question: {
      clicked: "question-clicked",
      removeClicked: "question-removeClicked",
    },
    CompletionPage: {
      clicked: "completionPage-clicked",
      removeClicked: "completionPage-removeClicked",
    },
    Response: {
      removeClicked: "response-removeClicked",
    },
  };
  static Serializers = {};

  constructor(el, attributes) {
    this.serializedOutput = this.serializedOutput.bind(this);
    this.el = assessmentRoot(el);
    if (attributes == null) {
      attributes = {};
    }
    attributes = humps.camelizeKeys(attributes);
    this.$el = jQuery(this.el);
    this.assessment = new AssessmentBuilder.Models.Assessment(attributes);
    const assessmentView = new AssessmentBuilder.Views.Assessment({
      model: this.assessment,
      selectItems: assessmentSelectItems(this.el),
    }).render();

    // INITIALIZE

    this.$el.append(assessmentView.el);
  }

  serializedOutput() {
    return AssessmentBuilder.Serializers.FormInput.serialize(this.assessment.toJSON(), "assessment");
  }
};

if (_previousAssessmentBuilder) {
  for (const key of Object.keys(_previousAssessmentBuilder)) {
    const incoming = _previousAssessmentBuilder[key];
    const current = window.AssessmentBuilder[key];
    if (current && typeof current === "object" && typeof incoming === "object") {
      Object.assign(current, incoming);
      if (key === "Views" && incoming.Mixins && current.Mixins) {
        Object.assign(current.Mixins, incoming.Mixins);
      }
    } else if (current === undefined) {
      window.AssessmentBuilder[key] = incoming;
    }
  }
}
